module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "bb8-block"
  }, [_h('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.block.fields.id == ''),
      expression: "block.fields.id == ''"
    }],
    staticClass: "bb8-form-control bb8-block-tweet-id",
    attrs: {
      "placeholder": "Paste a tweet ID and press enter",
      "required": ""
    },
    domProps: {
      "value": _vm.block.fields.id
    },
    on: {
      "keydown": [function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        $event.preventDefault();
        _vm.loadTweet($event)
      }, function($event) {
        if (_vm._k($event.keyCode, "delete", [8, 46])) { return; }
        _vm.removeBlock($event, true)
      }]
    }
  }), " ", _h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.block.fields.id != ''),
      expression: "block.fields.id != ''"
    }],
    staticClass: "bb8-block-tweet-wrapper"
  }, [_h('div', {
    staticClass: "bb8-block-tweet"
  }), " ", _h('a', {
    staticClass: "bb8-block-remove",
    on: {
      "click": function($event) {
        _vm.removeBlock()
      }
    }
  }, [_h('svg', {
    staticClass: "icon icon-remove"
  }, [_h('use', {
    attrs: {
      "xlink:href": "#icon-remove"
    }
  })])])]), " ", _vm._t("default")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2970c344!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blocks/TweetBlock.vue
// module id = 41
// module chunks = 0